export const BUILD_VERSION = '1.3.48';
